// This file was automatically generated from appchart.dialog.disablePatientPassport.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.dialog.disablePatientPassport');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.disablePatientPassport.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="pad10"><p class="el8Bold el8Spacer">Are you sure you want to disable this patient’s Passport account?</p><p class="el8AppText el8Spacer5">This patient will no longer be able to access Patient Passport, including the messages sent by the practice, visit summaries, and access to their clinical profile.</p><p class="el8AppText el8Spacer5">If you would like to restore the patient\'s access to Patient Passport after disabling, simply refresh the chart and re-invite the patient to Passport.</p></div>');
  if (!opt_sb) return output.toString();
};
